import { ActionService } from './../services/action.service';
import { Visit } from './../models/visit';
import { MessageService } from '../services/message.service';
import { Message } from '../common/message';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material';
import { ConfirmDeleteDialogComponent } from '../dialog/confirm-delete-dialog/confirm-delete-dialog.component';
import { VisitService } from '../services/visit.service';
import { PowertrainService } from '../services/powertrain.service';
import { WorkshopService } from '../services/workshop.service';
import { TroubleshootingService } from '../services/troubleshooting.service';

let ELEMENT_DATA = [];

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ['date', 'time', 'powertrain', 'engine', 'workshop', 'reviewed', 'actions'];
  dataSource = new MatTableDataSource();
  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  powerTrains: any;
  engines: any;
  workShops: any;
  actions: any;
  troubleShooting: any;
  resource: Visit = new Visit();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private ptService: PowertrainService,
    private service: VisitService,
    private formBuilder: FormBuilder,
    private msg: MessageService,
    private wsService: WorkshopService,
    private actionService: ActionService,
    private tsService: TroubleshootingService) {
    this.resource.orderHour = 1500;
    // اتشال `this.resource.orderNumber = 123;` - رقم ثابت كان بيتبعت مع الإنشاء
    // فيتخطى توليد السيرفر. الرقم بيتولّد على السيرفر دلوقتي.
  }

  ngOnInit() {
    this.setMessageForm();
    this.getResources();
    this.getPowertrains();
    this.getWorkShops();
    this.getActions();
    this.getTroubleShooting();

  }

  getWorkShops() {
    this.workShops = [];
    this.wsService.getAll()
      .subscribe(result => {
        this.workShops = this.workShops.concat(result);
        //temp code
        this.resource.workshopId = "1";
      })
  }

  getActions() {
    this.actions = [];
    this.actionService.getAll()
      .subscribe(result => {
        this.actions = this.actions.concat(result);
      })
  }

  getTroubleShooting() {
    this.troubleShooting = [];
    this.tsService.getAll()
      .subscribe(result => {
        this.troubleShooting = this.troubleShooting.concat(result);
      })
  }

  getPowertrains() {
    this.powerTrains = [];
    this.engines = [];
    this.ptService.getAll()
      .subscribe((result: any) => {
        this.powerTrains = this.powerTrains.concat(result);
        //temp code
        this.resource.powertrainId = "1";
        this.resource.motorId = "1";
        this.onPowerTrainChange(1);
        this.onEngineChange(1);
      })
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      date: ['', Validators.required],
      time: ['', Validators.required],
      hoursread: ['', Validators.required],
      requestType: ['', Validators.required],
      orderNumber: ['', Validators.required],
      orderHour: ['', Validators.required],
      actions: ['', Validators.required],
      notes: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
      supervisor: ['', Validators.required],
      generatorNumber: ['', Validators.required],
      reviewed: ['', Validators.required],
      accountId: ['', Validators.required],
      reviewerId: ['', Validators.required],
      powertrainId: ['', Validators.required],
      motorId: ['', Validators.required],
      workshopId: ['', Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll()
      .subscribe(result => {
        ELEMENT_DATA = ELEMENT_DATA.concat(result);
        this.updateDataSource();
      })
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave() {

    this.submitted = true;

    // if(!this.resource || this.resource.name.trim() == ''){
    //   return;
    // }

    // if (this.form.controls.status.errors) {
    //   return;
    // }

    // if (this.form.controls.hoursread.errors) {
    //   return;
    // }

    if (this.resource.id) {
      this.updateElement();
    } else {
      this.addElement();
    }

  }

  onPowerTrainChange(pt) {
    for (var obj of this.powerTrains) {
      if (obj.id == pt) {
        if (obj && obj.motors && obj.motors.length) {
          this.engines = obj.motors;
          return;
        } else {
          this.engines = [];
          return;
        }
      }
    }
    this.engines = [];
  }

  onEngineChange(engine) {
    for (var pt of this.powerTrains) {
      for (var e of pt.motors) {
        if (e.id == engine) {
          if (e && e.code) {
            this.resource.generatorNumber = e.code;
            return;
          }
        }
      }
    }
    this.resource.generatorNumber = null;
  }

  checkHoursRead(hoursread) {
    if (hoursread) {
      alert(hoursread);
    }
  }

  resetForm(ret?: boolean) {
    this.resource.reset();
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement() {
    this.service.create(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.SAVE);
        ELEMENT_DATA.push(result);
        this.updateDataSource();
        //this.resource = new Engine();
        this.resetForm();
      })
  }

  updateElement() {
    this.service.update(this.resource)
      .subscribe(result => {
        this.msg.alert(Message.UPDATE);
        ELEMENT_DATA.forEach((elem, index) => {
          if (elem.id === this.resource.id) {
            ELEMENT_DATA.splice(index, 1, result);
            return;
          }
        })

        this.updateDataSource();
        this.resetForm(true);
      })
  }

  editElement(ele: Visit) {

    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;

  }

  deleteElement(ele) {
    this.dialog.open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe(result => {
        if (result === "true") {
          this.service.delete(ele.id)
            .subscribe(result => {
              this.msg.alert(Message.DELETE);
              let index = ELEMENT_DATA.indexOf(ele);
              ELEMENT_DATA.splice(index, 1);
              this.updateDataSource();
            })
        } else {
          return;
        }
      });

  }

}
